module.exports = __webpack_public_path__ + "static/media/locationBlue.1352f81a.svg";